import React, { Component } from "react";
import { Button } from "@blueprintjs/core";
import styled from "styled-components";
import Led from "./Led";

const ViewerContainer = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  user-select: none;
`;

const LiveButton = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
`;

const Canvas = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: hsl(240, 3%, 12%);
`;

const Panel = styled.div`
  width: 960px;
  height: 960px;
  display: flex;
  flex-wrap: wrap;
`;

interface Props {
  document: {
    data: string;
    title: string;
    user: string;
  };
  pushToLive: (data: string, type: string) => void;
}

class Viewer extends Component<Props> {
  state = {
    title: "",
    pixels: null
  };

  componentDidMount() {
    let pixels = [];
    const colorData = this.props.document.data;
    const rows = colorData.match(/.{1,192}/g);
    for (const row in rows) {
      const columns = rows[row].match(/.{1,6}/g);
      for (const column in columns) {
        pixels.push("#" + columns[column]);
      }
    }
    this.setState({ pixels, title: this.props.document.title });
  }

  render() {
    return (
      <ViewerContainer>
        <LiveButton>
          <Button
            onClick={() => this.props.pushToLive(this.props.document.data, "art")}
            intent="primary"
            icon="upload"
          >
            Push to live
          </Button>
        </LiveButton>
        <Canvas>
          <Panel>
            {this.state.pixels !== null &&
              this.state.pixels.map((color, index) => (
                <Led key={index} color={color} />
              ))}
          </Panel>
        </Canvas>
      </ViewerContainer>
    );
  }
}

export default Viewer;
